import { isMobile } from "react-device-detect";
import { Box, Button, Divider, IconButton, InputAdornment, OutlinedInput, Stack, Tooltip, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import DepartmentTable from "./table";
import { Outlet, useNavigate } from "react-router";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import CachedIcon from "@mui/icons-material/Cached";
import { useTheme } from "@mui/material/styles";
import Loader from "../../common/loader";
import { toast } from "react-toastify";
import { isLogin } from "../../../services/authService";
import { getTestimonials } from "../../../services/testimonialService";
import TestimonialTable from "./table";

export default function Testimonials() {
    const navigate = useNavigate();
    const [search, setSearch] = useState("");
    const [reload, setReload] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [testimonials, setTestimonials] = useState([]);
    const [filteredTestimonials, setFilteredTestimonials] = useState([]);

    useEffect(() => {
        document.title = "Techlogics | Testimonials";
        if (!isLogin()) navigate("/admin-login");

        getTestimonials()
            .then((res) => {
                setTestimonials(res.data.data);
                setFilteredTestimonials(res.data.data);
                setIsLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setIsLoading(false);
            });
    }, [reload]);

    const handleSearch = (e) => {
        setSearch(e.target.value);
        if (e.target.value === "") {
            setFilteredTestimonials(testimonials);
        } else {
            const filtered = testimonials.filter((testimonial) => {
                return testimonial.name.toLowerCase().includes(e.target.value.toLowerCase());
            });
            setFilteredTestimonials(filtered);
        }
    };

    const handleClearSearch = () => {
        setSearch("");
        setFilteredTestimonials(testimonials);
    };

    const handleRefresh = () => {
        setSearch("");
        setIsLoading(true);
        setReload(!reload);
        toast.success("Testimonials Refreshed");
    };

    return (
        <Box p={2} gap={2} sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" } }}>
            <Box width={{ xs: "100%", sm: "90%" }}>
                <Stack direction={"row"} gap={1} alignItems={"center"}>
                    <Typography className='purple' variant='h6'>
                        Testimonial List
                    </Typography>
                    <Tooltip title='Refresh' placement='right'>
                        <IconButton size='small' onClick={handleRefresh}>
                            <CachedIcon />
                        </IconButton>
                    </Tooltip>
                </Stack>
                <Box py={1} sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 1, alignItems: "center" }}>
                    <OutlinedInput
                        fullWidth
                        type='text'
                        placeholder='Search Testimonial'
                        sx={{
                            flex: 1,
                        }}
                        size='small'
                        value={search}
                        onChange={handleSearch}
                        endAdornment={
                            <Tooltip title='Clear'>
                                <IconButton onClick={handleClearSearch}>
                                    <FilterAltOffIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        startAdornment={
                            <InputAdornment position='start'>
                                <SearchIcon color='primary' sx={{ marginRight: 1 }} />
                            </InputAdornment>
                        }
                    />
                    <Button
                        // fullWidth={{ xs: true, md: false }}
                        size={isMobile ? "small" : "medium"}
                        variant='contained'
                        color=''
                        sx={{ color: "#30369e" }}
                        onClick={() => navigate("/admin/testimonials/tab=7/add")}
                    >
                        Add Testimonial
                    </Button>
                </Box>
                {isLoading && <Loader message={"Fetching testimonials"} />}
                {!isLoading && <TestimonialTable filteredTestimonials={filteredTestimonials} />}
            </Box>
            <Divider orientation={isMobile ? "horizontal" : "vertical"} flexItem />
            <Box width={"100%"} sx={{ xs: 0, sm: 1 }}>
                <Outlet />
            </Box>
        </Box>
    );
}
